<script>
  export let vertical = false;
  export const size = 'md';
  export let attached = true; // 버튼들이 붙어있는지 여부
  export let responsive = false; // 반응형 모드
</script>

<div 
  class="btn-group" 
  class:btn-group-vertical={vertical}
  class:btn-group-attached={attached}
  class:btn-group-responsive={responsive}
  role="group"
  {...$$restProps}
>
  <slot />
</div>

<style>
  .btn-group {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
  }

  .btn-group-vertical {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  /* 붙어있는 버튼 그룹 스타일 */
  .btn-group-attached :global(.btn) {
    position: relative;
    flex: 1 1 auto;
  }

  .btn-group-attached :global(.btn:not(:first-child)) {
    margin-left: -1px;
  }

  .btn-group-attached:not(.btn-group-vertical) :global(.btn:not(:first-child)) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .btn-group-attached:not(.btn-group-vertical) :global(.btn:not(:last-child)) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .btn-group-attached.btn-group-vertical :global(.btn:not(:first-child)) {
    margin-left: 0;
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .btn-group-attached.btn-group-vertical :global(.btn:not(:last-child)) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .btn-group-attached :global(.btn:hover),
  .btn-group-attached :global(.btn:focus),
  .btn-group-attached :global(.btn:active) {
    z-index: 1;
  }

  /* 분리된 버튼 그룹 스타일 */
  .btn-group:not(.btn-group-attached) {
    gap: var(--spacing-xs);
  }

  .btn-group:not(.btn-group-attached).btn-group-vertical {
    gap: var(--spacing-xs);
  }

  /* 반응형 버튼 그룹 */
  .btn-group-responsive {
    flex-wrap: wrap;
    gap: var(--spacing-sm);
  }

  @media (max-width: 768px) {
    .btn-group-responsive {
      flex-direction: column;
      gap: var(--spacing-xs);
      width: 100%;
    }

    .btn-group-responsive :global(.btn) {
      border-radius: var(--border-radius-md) !important;
      margin: 0 !important;
      width: 100%;
    }

    .btn-group-responsive :global(.btn:not(:first-child)) {
      border-radius: var(--border-radius-md) !important;
      margin-left: 0 !important;
      margin-top: 0 !important;
    }

    .btn-group-responsive :global(.btn:not(:last-child)) {
      border-radius: var(--border-radius-md) !important;
    }
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .btn-group-responsive {
      flex-wrap: wrap;
      gap: var(--spacing-sm);
    }

    .btn-group-responsive :global(.btn) {
      flex: 1;
      min-width: 140px;
    }
  }
</style> 